module.exports = __webpack_public_path__ + "static/media/feature-scheduling.dbb1853d.png";